import { useIntl } from "react-intl";

import { GuardLogo } from "@atlaskit/logo";
import UFOSegment from "@atlaskit/react-ufo/segment";
import { Editions } from "@atlassiansox/asc-stargate";

import { useCrossFlowFrontendTouchpoint } from "@/components/cross-flow/touchpoint";
import { useLocalizedHref } from "@/libraries/web-framework";
import { ProductPageSubNav } from "@/patterns/global-nav/src";

export const GuardNav = () => {
    const intl = useIntl();
    const signupLink = "https://admin.atlassian.com/atlassian-guard";
    const { openCrossFlow } = useCrossFlowFrontendTouchpoint({
        edition: Editions.FREE,
        redirectUrl: signupLink
    });
    const capabilitiesHref = useLocalizedHref("/software/guard/capabilities");
    const pricingHref = useLocalizedHref("/software/guard/pricing");
    const guideHref = useLocalizedHref("/software/guard/guide#getting-started");
    const demoHref = useLocalizedHref("/software/guard/demo");

    return (
        <UFOSegment name="confluence-pt-cfind-1234-GuardNav">
            <ProductPageSubNav
                productLogoUrl="/software/guard"
                productLogo={<GuardLogo appearance="brand" />}
                productLogoAriaLabel={intl.formatMessage({
                    id: "GuardPageTemplate.navbar.guard-logo",
                    defaultMessage: "Guard logo"
                })}
                mobileCtaText={intl.formatMessage({
                    id: "GuardPageTemplate.navbar.tryitfree",
                    defaultMessage: "Try it free"
                })}
                navigationTrynowCtaText={intl.formatMessage({
                    id: "GuardPageTemplate.navbar.tryitfree",
                    defaultMessage: "Try it free"
                })}
                mobileCtaUrl={signupLink}
                mobileCtaOnClick={openCrossFlow}
                mobileLogo={<GuardLogo appearance="brand" />}
                productPageNavLinks={[
                    {
                        globalLinksKey: "capabilities",
                        linkText: intl.formatMessage({
                            id: "GuardPageTemplate.navbar.capabilities",
                            defaultMessage: "Capabilities"
                        }),
                        hasSubnav: false,
                        productKey: "guard",
                        href: capabilitiesHref
                    },
                    {
                        globalLinksKey: "pricing",
                        linkText: intl.formatMessage({
                            id: "GuardPageTemplate.navbar.pricing",
                            defaultMessage: "Pricing"
                        }),
                        hasSubnav: false,
                        productKey: "guard",
                        href: pricingHref
                    },
                    {
                        globalLinksKey: "guide",
                        linkText: intl.formatMessage({
                            id: "GuardPageTemplate.navbar.guide",
                            defaultMessage: "Guide"
                        }),
                        hasSubnav: false,
                        productKey: "guard",
                        href: guideHref
                    },
                    {
                        globalLinksKey: "demo",
                        linkText: intl.formatMessage({
                            id: "GuardPageTemplate.navbar.demo",
                            defaultMessage: "Demo"
                        }),
                        hasSubnav: false,
                        productKey: "guard",
                        href: demoHref
                    }
                ]}
                navigationTrynowCtaUrl={signupLink}
                navigationTrynowCtaOnClick={openCrossFlow}
                mobileLinksSections={[
                    {
                        mobileLinkKey: "mobile-guard",
                        mobileLinksProps: [
                            {
                                globalLinksKey: "capabilities",
                                linkText: intl.formatMessage({
                                    id: "GuardPageTemplate.navbar.capabilities",
                                    defaultMessage: "Capabilities"
                                }),
                                hasSubnav: false,
                                productKey: "guard",
                                href: capabilitiesHref
                            },
                            {
                                globalLinksKey: "pricing",
                                linkText: intl.formatMessage({
                                    id: "GuardPageTemplate.navbar.pricing",
                                    defaultMessage: "Pricing"
                                }),
                                hasSubnav: false,
                                productKey: "guard",
                                href: pricingHref
                            },
                            {
                                globalLinksKey: "guide",
                                linkText: intl.formatMessage({
                                    id: "GuardPageTemplate.navbar.guide",
                                    defaultMessage: "Guide"
                                }),
                                hasSubnav: false,
                                productKey: "guard",
                                href: guideHref
                            },
                            {
                                globalLinksKey: "demo",
                                linkText: intl.formatMessage({
                                    id: "GuardPageTemplate.navbar.demo",
                                    defaultMessage: "Demo"
                                }),
                                hasSubnav: false,
                                productKey: "guard",
                                href: demoHref
                            }
                        ]
                    }
                ]}
            />
        </UFOSegment>
    );
};
